<template>
	<div class="home">
		<center>
			<img class="logo" src="../assets/logo-404.png"/>
			<br>
			<h1>Not Found</h1>
			<p>
				The page you were looking for does not exist.
			</p>
		</center>
	</div>
</template>

<style scoped>
center {
	margin-top: 20vh;
}
.logo {
	width: 180px;
}
</style>

<script>
export default {
	name: 'NotFound',
}
</script>